import { computed, observable } from 'mobx';
import { BaseBlock } from '~/models/blocks/base-block.model';
import type { ScheduleContainerBlock } from '~/models/blocks/schedule-container-block.model';
import type { FlowRevision } from '~/models/flow-revision.model';
import type { RootStore } from '~/stores/root.store';
import { IScheduleSessionBlockStyles } from '~/types/block-styles.types';
import { IScheduleSessionBlockResponse } from '~/types/server.types';

type ScheduleSessionBlockDataForServer = ReturnType<
    BaseBlock['getDataForServer']
> &
    Pick<IScheduleSessionBlockResponse, 'type'>;

export class ScheduleSessionBlock extends BaseBlock {
    type: 'schedule_session_block';
    @observable styles: IScheduleSessionBlockStyles;

    constructor(
        block: IScheduleSessionBlockResponse,
        flowRevision: FlowRevision<RootStore>,
        rootStore: RootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    dndAcceptedTypes() {
        return null;
    }

    isDraggable() {
        return false;
    }

    get isDeletable() {
        return false;
    }

    @computed
    get shouldExpandOnSelect() {
        return false;
    }

    @computed
    get scheduleContainerBlock(): ScheduleContainerBlock {
        return this.parent as ScheduleContainerBlock;
    }

    @computed
    get errors() {
        const {
            builderUiStore: { showErrors }
        } = this.rootStore;

        if (!showErrors) {
            return {};
        }

        const errors: any = {};
        if (
            !this.flow.sessionSelectionBlock &&
            !this.scheduleContainerBlock.sessionConfig
        ) {
            errors.hasErrors = true;
        }

        return errors;
    }

    getDataForServer(): ScheduleSessionBlockDataForServer {
        return {
            ...super.getDataForServer(),
            type: this.type as 'schedule_session_block'
        };
    }
}
